<lib-card>
  <lib-card-header>
    <div class="row mb-3">
      <div class="col-md-6">
        <strong>{{'DATA_STUDIO.PAGER.DATA_PREVIEW' | translate }}</strong>
      </div>
      <div class="col-md-6 text-right">
        <div class="input-prepend">
          <lib-button
            id="data-studio-redesign-button-close-preview"
            class="mr-2"
            [color]="'secondary'"
            [faIcon]="'far fa-eye'"
            [label]="'DATA_STUDIO.DATA_FILE_SUMMARY.CLOSE_PREVIEW' | translate"
            (buttonClicked)="close()">
          </lib-button>
        </div>
      </div>
    </div>

  </lib-card-header>
  <lib-card-body>
    <mat-tab-group animationDuration="100ms" [(selectedIndex)]="selectedTab">
      <mat-tab [label]="('DATA_STUDIO.PREVIEW.SINGLE_DEVICE' | translate)">
        <div class="d-flex flex-wrap">
          <div class="p-2 signals-preview-dropdown">
            <mat-label>{{'COMMON.DEVICE' | translate }}</mat-label>
            @if (devicesNames) {
              <lib-select
                [options]="devicesNames"
                [label]="selectedDeviceLabel"
                id="data-studio-redesign-select-device"
                [border]="'custom-border'"
                [classes]="'font-size-normal-small text-primary h-100'"
                [notBold]="true"
                [fullWidth]="true"
                [itemClasses]="'font-size-normal-small'"
                [doNotTranslate]="true"
                [container]="''"
                (selectedChanged)="triggerDeviceChange($event)">
              </lib-select>
            }
          </div>
          <div class="p-2 w-50">
            <mat-label>{{'DATA_STUDIO.PREVIEW.SIGNALS' | translate}}</mat-label>
            <mat-select [formControl]="multiSignals" disableOptionCentering panelClass="multi-panel" multiple>
              <mat-select-trigger>
                {{multiSignalsText}}
              </mat-select-trigger>
              <div class="select-all-option" [ngClass]="{'disabled': allUnitsCount > MAX_UNITS_COUNT}">
                <mat-checkbox [checked]="allSignalsSelected" class="w-100" (change)="triggerAllSignals($event)" [disabled]="allUnitsCount > MAX_UNITS_COUNT">
                  <div class="d-flex justify-content-between">
                    <div class="d-flex align-items-center justify-content-start">
                      <div>{{'DATA_STUDIO.PREVIEW.SELECT_ALL' | translate }}</div>
                      <div class="ml-2">({{ 'DATA_STUDIO.PREVIEW.ONLY_2_DIFFERENT_UNITS_BY_CHART' | translate }})</div>
                    </div>
                    <div class="d-flex align-items-center justify-content-end">
                      {{' ' + multiSignals.value?.length}} {{'COMMON.OF' | translate}} {{selectedDevice?.signals?.length}}
                    </div>
                  </div>
                </mat-checkbox>
              </div>

              <div class="signal-grid">
                @for (signal of signals; track $index; let i = $index) {
                  <mat-option
                    [value]="signal"
                    [matTooltip]="signal"
                    [disabled]="!isSignalSelected(signal) && unitsSelected.length === MAX_UNITS_COUNT"
                    class="data-studio-multi-select"
                    (click)="triggerOnePerOneSignal(signal)">
                    {{signal}}
                  </mat-option>
                }
              </div>
            </mat-select>
          </div>
          @if (selectedTab === 0) {
            <app-preview-chart
              class="w-100"
              [loading]="loadingData"
              [unitsSelected]="unitsSelected"
              [series]="series">
            </app-preview-chart>
          }
        </div>
      </mat-tab>
      <mat-tab [label]="('DATA_STUDIO.PREVIEW.MULTIPLE_DEVICES' | translate)">
        <div class="d-flex flex-wrap">
          <div class="p-2 signals-preview-dropdown">
            <mat-label>{{'DATA_STUDIO.PREVIEW.SIGNALS' | translate}}</mat-label>
            @if (signalsNames) {
              <lib-select
                [options]="signalsNames"
                [label]="selectedSignalLabel"
                [doNotTranslate]="true"
                id="data-studio-redesign-select-signal-change"
                [border]="'custom-border'"
                [classes]="'font-size-normal-small text-primary h-100'"
                [notBold]="true"
                [fullWidth]="true"
                [itemClasses]="'font-size-normal-small'"
                [container]="''"
                (selectedChanged)="triggerSignalChange($event)">
              </lib-select>
            }
          </div>
          <div class="p-2 w-50">
            <mat-label>{{'COMMON.DEVICES' | translate}}</mat-label>
            <mat-select
              disableOptionCentering
              #multiDevicesSelect
              panelClass="multi-panel"
              multiple
              [formControl]="multiDevices">
              <mat-select-trigger>
                {{multiDevicesText}}
              </mat-select-trigger>
              <div class="select-all-option">
                <mat-checkbox [checked]="allDevicesSelected" (change)="triggerAllDevices($event)">
                  <div class="d-flex justify-content-between">
                    <div class="text-primary">{{'DATA_STUDIO.PREVIEW.SELECT_ALL' | translate }}</div>
                    <div class="d-flex align-items-center justify-content-end">
                      {{' ' + multiDevices.value?.length}} {{'COMMON.OF' | translate}} {{selectedSignal?.devices?.length}}
                    </div>
                  </div>
                </mat-checkbox>
              </div>
              <div class="signal-grid">
                @for (device of devices; track $index; let i = $index) {
                  <mat-option class="data-studio-multi-select"
                    [value]="device" (click)="triggerOnePerOneDevice()">
                    {{ device }}
                  </mat-option>
                }
              </div>
            </mat-select>
          </div>
          @if (selectedTab === 1) {
            <app-preview-chart
              class="w-100"
              [loading]="loadingData"
              [unitsSelected]="unitsMultiDeviceSelected"
              [series]="seriesMultiDevice">
            </app-preview-chart>
          }
        </div>
      </mat-tab>
    </mat-tab-group>
  </lib-card-body>
</lib-card>
